"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Rater;
Object.defineProperty(exports, "Star", {
  enumerable: true,
  get: function get() {
    return _star["default"];
  }
});

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _star = _interopRequireDefault(require("./star"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

function Rater(props) {
  var _this = this;

  var total = props.total,
      interactive = props.interactive,
      children = props.children,
      defaultRating = props.rating,
      onRate = props.onRate,
      onRating = props.onRating,
      onCancelRate = props.onCancelRate,
      restProps = _objectWithoutProperties(props, ["total", "interactive", "children", "rating", "onRate", "onRating", "onCancelRate"]);

  var _useState = (0, _react.useState)({
    rating: props.rating,
    isRating: false
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var rating = state.rating,
      isRating = state.isRating;
  var lastRating = (0, _react.useRef)(rating);

  var childElements = _react.Children.toArray(children);

  function updateState(vals) {
    setState(function (prevState) {
      return _objectSpread({}, prevState, {}, vals);
    });
  }

  function willRate(rating, e) {
    updateState({
      rating: rating,
      isRating: true
    });
    onRating && onRating(_objectSpread({}, e, {
      rating: rating
    }));
  }

  function rate(rating, e) {
    updateState({
      rating: rating,
      isRating: false
    });
    lastRating.current = rating;
    onRate && onRate(_objectSpread({}, e, {
      rating: rating
    }));
  }

  function cancelRate() {
    updateState({
      rating: lastRating.current,
      isRating: false
    });
    onCancelRate && onCancelRate({
      rating: rating
    });
  }

  (0, _react.useEffect)(function () {
    updateState({
      rating: defaultRating
    });
  }, [defaultRating]);
  var nodes = Array.from(Array(total), function (_, i) {
    var starProps = {
      isActive: !isRating && rating - i >= 1,
      willBeActive: isRating && i < rating,
      isActiveHalf: !isRating && rating - i >= 0.5 && rating - i < 1,
      isDisabled: !interactive
    };
    return _react["default"].createElement("div", {
      key: "star-".concat(i),
      onClick: interactive ? rate.bind(_this, i + 1) : null,
      onMouseOver: interactive ? willRate.bind(_this, i + 1) : null
    }, childElements.length ? _react["default"].cloneElement(childElements[i % childElements.length], starProps) : _react["default"].createElement(_star["default"], starProps));
  });
  return _react["default"].createElement("div", _extends({
    className: "react-rater"
  }, interactive ? {
    onMouseOut: cancelRate
  } : {}, restProps), nodes);
}

__signature__(Rater, "useState{[state, setState]({\n    rating: props.rating,\n    isRating: false\n  })}\nuseRef{lastRating}\nuseEffect{}");

Rater.propTypes = {
  total: _propTypes["default"].number,
  rating: _propTypes["default"].number,
  interactive: _propTypes["default"].bool,
  children: _propTypes["default"].any,
  onRate: _propTypes["default"].func,
  onRating: _propTypes["default"].func,
  onCancelRate: _propTypes["default"].func
};
Rater.defaultProps = {
  total: 5,
  rating: 0,
  interactive: true
};
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Rater, "Rater", "/Users/simon/Develop/personal/react-rater/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();